<template>
  <card title="Horizontal Form">
    <h4 slot="header" class="card-title">
      LINE Module Console
    </h4>
    <form class="form-horizontal" action="#" method="#" @submit.prevent>
      <div class="row">
        <label class="col-md-3 col-form-label">輸入解除綁定accountId</label>
        <div class="col-md-6">
          <fg-input placeholder="" v-model="accountId"></fg-input>
        </div>
        <div class="col-md-3">
          <n-button type="primary" @click.native="detach()">
            解綁
          </n-button>
        </div>
      </div>
    </form>
  </card>
</template>

<script>
import { Checkbox, Radio } from "src/components/index";
import { delLineModule } from "src/javascripts/generalPages/deleteData";

import axios from "axios";
import swal from "sweetalert2";

export default {
  components: {
    Checkbox,
    Radio
  },
  data() {
    return {
      accountId: ""
    };
  },
  mounted() {},
  methods: {
    detach() {
      console.log("detach!");
      delLineModule(this.accountId)
        .then(delLineModuleRes => {
          console.log("delLineModuleRes: ", delLineModuleRes);
          swal("解除綁定完成")
        })
        .catch(delLineModuleErr => {
          console.log("delLineModuleErr: ", delLineModuleErr);
          swal("解除綁定失敗")
        });
    },
    test() {
      console.log("test");
    }
  },
  watch: {
    accountId: function(val, old) {
      console.log("accountId: ", val, old);
    }
  }
};
</script>
